import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

import Image from "~/components/Image";
import { Link } from "@remix-run/react";
import Logo from "../svgs/logo";
import Newsletter from "./newsletter";
import { translations } from "./localTranslation";

const ShopLinks = (locale = "se") => {
  const t = translations[locale];
  return (
    <ul className="grid gap-3 mt-3">
      <li>
        <Link to={`${locale}/posters`}>{t.exploreLinkLabel}</Link>
      </li>

      <li>
        <Link to={`${locale}/new-arrivals`}>{t.latestLinkLabel}</Link>
      </li>
      <li>
        <Link to={`${locale}/bestsellers`}>{t.popularLinkLabel}</Link>
      </li>
    </ul>
  );
};

const CompanyLinks = (locale: string) => {
  const t = translations[locale];
  return (
    <ul className="grid gap-3 mt-3">
      <li>
        <Link to={`${locale}/about-us`}>{t.aboutLinkLabel}</Link>
      </li>
      <li>
        <Link to={`${locale}/terms-and-conditions`}>{t.termsLinkLabel}</Link>
      </li>
      <li>
        <Link to={`${locale}/privacy-policy`}>{t.privacyLinkLabel}</Link>
      </li>
    </ul>
  );
};

const helpLinks = (locale: string) => {
  const t = translations[locale];

  return (
    <ul className="grid gap-3 mt-3">
      <li>
        <Link to={`${locale}/contact`}>{t.contactLinkLabel}</Link>
      </li>
      <li>
        <Link to={`/${locale}/contact/faq`}>{t.faqLinkLabel}</Link>
      </li>
    </ul>
  );
};

const connectLinks = (locale: string) => {
  const t = translations[locale];

  return (
    <ul className="grid gap-3 mt-3">
      <li>
        <Link to={`${locale}/contact`}>{t.joinArtistLabel}</Link>
      </li>

      <li className="block lg:hidden">
        <Link
          to="https://www.instagram.com/NordicPosterStore/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Instagram
        </Link>
      </li>
      <li className="block lg:hidden">
        <Link
          to="https://www.facebook.com/NordicPosterStore/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Facebook
        </Link>
      </li>
      <li className="block lg:hidden">
        <Link
          to="https://www.linkedin.com/company/NordicPosterStore/"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </Link>
      </li>
    </ul>
  );
};

const socialLinks = () => {
  return (
    <ul className="flex gap-5 lg:gap-3 mt-6 lg:mt-3">
      <li>
        <Link
          to="https://www.instagram.com/NordicPosterStore/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 560 542"
            width={24}
            height={24}
          >
            <title>Instagram</title>
            <desc>Instagram Icon</desc>
            <path
              d="M280.5 350.316c44.633 0 80.816-36.182 80.816-80.816s-36.183-80.816-80.816-80.816-80.816 36.182-80.816 80.816 36.183 80.816 80.816 80.816zm0-205.316c68.76 0 124.5 55.74 124.5 124.5 0 68.76-55.74 124.5-124.5 124.5-68.76 0-124.5-55.74-124.5-124.5 0-68.76 55.74-124.5 124.5-124.5zM410 111c16.017 0 29 12.984 29 29s-12.983 29-29 29-29-12.984-29-29 12.983-29 29-29zm67.892 256.49c1.167-25.57 1.414-33.239 1.414-97.99 0-64.75-.247-72.42-1.414-97.99-1.079-23.643-5.028-36.485-8.35-45.03-4.398-11.319-9.654-19.397-18.14-27.882-8.485-8.486-16.564-13.742-27.882-18.14-8.545-3.322-21.387-7.271-45.03-8.35-25.57-1.167-33.24-1.414-97.99-1.414-64.751 0-72.42.247-97.992 1.414-23.642 1.079-36.483 5.028-45.028 8.35-11.319 4.398-19.397 9.654-27.883 18.14-8.486 8.485-13.742 16.563-18.14 27.882-3.32 8.545-7.271 21.387-8.35 45.03-1.167 25.57-1.413 33.24-1.413 97.99 0 64.751.246 72.42 1.413 97.99 1.079 23.644 5.03 36.485 8.35 45.03 4.398 11.319 9.654 19.397 18.14 27.883s16.564 13.74 27.883 18.14c8.545 3.32 21.386 7.271 45.03 8.35 25.566 1.167 33.235 1.413 97.99 1.413 64.754 0 72.423-.246 97.99-1.413 23.643-1.079 36.485-5.03 45.03-8.35 11.318-4.4 19.397-9.654 27.882-18.14 8.486-8.486 13.742-16.564 18.14-27.883 3.322-8.545 7.271-21.386 8.35-45.03zm43.649-197.972C522.72 195.383 523 203.64 523 269.5c0 65.859-.28 74.117-1.46 99.982-1.178 25.813-5.276 43.44-11.271 58.866-6.198 15.945-14.49 29.47-27.97 42.951-13.482 13.481-27.006 21.773-42.952 27.97-15.426 5.995-33.053 10.094-58.866 11.272C354.617 511.72 346.36 512 280.5 512c-65.86 0-74.117-.278-99.982-1.46-25.813-1.177-43.44-5.276-58.866-11.27-15.946-6.198-29.47-14.49-42.951-27.97-13.481-13.482-21.773-27.007-27.97-42.952-5.996-15.426-10.094-33.053-11.273-58.866C38.278 343.617 38 335.36 38 269.5c0-65.859.278-74.117 1.458-99.982 1.179-25.812 5.277-43.439 11.272-58.865 6.198-15.946 14.49-29.47 27.97-42.951 13.482-13.482 27.006-21.773 42.952-27.97 15.426-5.996 33.053-10.095 58.866-11.273C206.383 27.28 214.64 27 280.5 27c65.859 0 74.117.28 99.981 1.46 25.813 1.177 43.44 5.276 58.866 11.271 15.946 6.198 29.47 14.489 42.951 27.97 13.481 13.482 21.773 27.006 27.97 42.952 5.996 15.426 10.094 33.053 11.273 58.865z"
              fillRule="evenodd"
              fill="#ffffff"
            />
          </svg>
        </Link>
      </li>
      <li>
        <Link
          to="https://www.facebook.com/NordicPosterStore/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={21}
            height={21}
          >
            <title>Facebook</title>
            <desc>Facebook logo</desc>
            <path
              d="M9 8H6v4h3v12h5V12h3.642L18 8h-4V6.332C14 5.378 14.191 5 15.115 5H18V0h-3.809C10.596 0 9 1.583 9 4.614Z"
              fillRule="evenodd"
              fill="#ffffff"
            />
          </svg>
        </Link>
      </li>
      <li>
        <Link
          to="https://www.linkedin.com/company/NordicPosterStore/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={34}
            height={32}
            viewBox="6 3 28 28"
          >
            <title>LinkedIn</title>
            <desc>LinkedIn logo</desc>
            <path
              d="M8.13375 19.0001H5.23125V9.65318H8.13375V19.0001ZM6.68094 8.37818C5.75281 8.37818 5 7.60943 5 6.6813C5 6.23549 5.1771 5.80794 5.49234 5.4927C5.80757 5.17746 6.23513 5.00037 6.68094 5.00037C7.12675 5.00037 7.5543 5.17746 7.86954 5.4927C8.18478 5.80794 8.36188 6.23549 8.36188 6.6813C8.36188 7.60943 7.60875 8.37818 6.68094 8.37818ZM18.9969 19.0001H16.1006V14.4501C16.1006 13.3657 16.0787 11.9751 14.5916 11.9751C13.0825 11.9751 12.8513 13.1532 12.8513 14.3719V19.0001H9.95188V9.65318H12.7356V10.9282H12.7762C13.1637 10.1938 14.1103 9.4188 15.5225 9.4188C18.46 9.4188 19 11.3532 19 13.8657V19.0001H18.9969Z"
              fill="#ffffff"
            />
          </svg>
        </Link>
      </li>
    </ul>
  );
};

export const Footer = ({ locale }: { locale: string }) => {
  const t = translations[locale];

  return (
    <footer className="px-4 md:p-8 lg:p-12 bg-black">
      <div className="md:hidden py-8 text-white ">
        <Newsletter
          noEmailNoGoodieLabel={t.noEmailNoGoodieLabel}
          welcomeToCommunityLabel={t.welcomeToCommunityLabel}
          newsletterEmailLabel={t.newsletterEmailLabel}
          newsletterButtonLabel={t.newsletterButtonLabel}
          newsletterLabel={t.newsletterLabel}
        />

        {socialLinks()}
        <Accordion type="single" collapsible className="w-full">
          <AccordionItem value="item-1">
            <AccordionTrigger className="font-masonExtendedBold">
              {t.shopLinkLabel}
            </AccordionTrigger>
            <AccordionContent>{ShopLinks(locale ?? "se")}</AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-2">
            <AccordionTrigger className="font-masonExtendedBold">
              {t.helpLinkLabel}
            </AccordionTrigger>
            <AccordionContent>{helpLinks(locale)}</AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-3">
            <AccordionTrigger className="font-masonExtendedBold">
              {t.companyLinkLabel}
            </AccordionTrigger>

            <AccordionContent>{CompanyLinks(locale)}</AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-4">
            <AccordionTrigger className="font-masonExtendedBold">
              {t.connectLinkLabel}
            </AccordionTrigger>

            <AccordionContent>{connectLinks(locale)}</AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>

      <div className="hidden md:grid grid-flow-col text-white pt-2">
        <div className="flex flex-col">
          <span className="font-masonExtendedBold">{t.shopLinkLabel}</span>

          {ShopLinks(locale)}
        </div>

        <div className="flex flex-col">
          <span className="font-masonExtendedBold">{t.helpLinkLabel}</span>

          {helpLinks(locale)}
        </div>

        <div className="flex flex-col">
          <span className="font-masonExtendedBold">{t.companyLinkLabel}</span>

          {CompanyLinks(locale)}
        </div>

        <div>
          <span className="font-masonExtendedBold">{t.connectLinkLabel}</span>
          {connectLinks(locale)}

          <div className="pt-4" />

          <Newsletter
            noEmailNoGoodieLabel={t.noEmailNoGoodieLabel}
            welcomeToCommunityLabel={t.welcomeToCommunityLabel}
            newsletterEmailLabel={t.newsletterEmailLabel}
            newsletterButtonLabel={t.newsletterButtonLabel}
            newsletterLabel={t.newsletterLabel}
          />
        </div>

        <div className="hidden lg:flex lg:flex-col gap-4  items-center justify-center">
          <Link
            aria-label="Nordic Poster Store Home"
            to={`/${locale}`}
            className="font-masonExtendedExtraBold flex flex-col gap-2 col-span-1 text-center  justify-center items-center"
          >
            <Logo />
          </Link>
          {socialLinks()}
        </div>
      </div>

      <div className="flex flex-col-reverse md:flex-row justify-between items-center mt-4 md:mt-8">
        <p className="text-white text-xs my-8 md:my-0">
          © 2025 NordicPosterStore
        </p>

        <ul className="flex items-center sm:px-0 px-4 lg:order-none order-1 flex-wrap justify-center lg:justify-end">
          <li
            title="Klarna"
            className="py-[0.25rem] px-[0.6rem] relative rounded-[0.375rem] border w-14 h-8 bg-[#f4b6c7] border-[#f4b6c7] mx-2 lg:last:me-0 "
          >
            <div className="relative h-full">
              <img
                alt="Klarna logo"
                loading="lazy"
                width="128"
                height="28"
                decoding="async"
                data-nimg="1"
                srcSet="https://cdn.sanity.io/images/n8c7yri3/production/2434df94727a57879cf7019a264cc363cb423349-128x28.webp?w=256&q=75&fit=max&auto=format"
                className="object-contain w-full h-full transparent"
              />
            </div>
          </li>

          {locale === "se" && (
            <li
              title="Swish"
              className="py-[0.25rem] px-[0.6rem] relative rounded-[0.375rem] border w-14 h-8 bg-white mx-2 lg:last:me-0"
            >
              <div className="relative h-full">
                <img
                  alt="Swish logo"
                  loading="lazy"
                  width="128"
                  height="28"
                  decoding="async"
                  data-nimg="1"
                  srcSet="https://cdn.sanity.io/images/n8c7yri3/production/ec46d30730ef701971f873515d0dfc4e5d5c38c4-128x128.webp?w=256&q=75&fit=max&auto=format"
                  className="object-contain w-full h-full transparent"
                />
              </div>
            </li>
          )}

          <li
            title="Visa"
            className="py-[0.25rem] px-[0.6rem] relative rounded-[0.375rem] border w-14 h-8 bg-white mx-2 lg:last:me-0"
          >
            <div className="relative h-full">
              <img
                alt="Visa logo"
                loading="lazy"
                width="128"
                height="28"
                decoding="async"
                data-nimg="1"
                srcSet="https://cdn.sanity.io/images/n8c7yri3/production/048a33a0ef86f0ab1fbcb17cc7fdc44f0c9afab7-128x42.webp?w=256&q=75&fit=max&auto=format"
                className="object-contain w-full h-full transparent"
              />
            </div>
          </li>
          <li
            title="Mastercard"
            className="py-[0.25rem] px-[0.6rem] relative rounded-[0.375rem] border w-14 h-8 bg-white mx-2 lg:last:me-0"
          >
            <div className="relative h-full">
              <img
                alt="Mastercard logo"
                loading="lazy"
                width="128"
                height="28"
                decoding="async"
                data-nimg="1"
                srcSet="https://cdn.sanity.io/images/n8c7yri3/production/7f676cfc5a52127b102fb82a28e14c81c8eeeed7-128x82.webp?w=256&q=75&fit=max&auto=format"
                className="object-contain w-full h-full transparent"
              />
            </div>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
